export default "/images/vendor/flag-icon-css/flags/4x3/bz.svg?4eb2d29f4fcc586ae3e27a74fb073cdb";